import React from 'react';
import { useParams } from 'react-router-dom';
import PaginaPublica from '../components/bodas/PaginaPublica';
import { bodasApi } from '../components/bodas/bodasUtils';

const tituloBoda = (b) => `Boda de ${b.persona_a} & ${b.persona_b}`;
const tituloReferido = (t) => `${t.nombre_referente} te invita`;

export function BodaPublica() {
  const { slug } = useParams();
  return <PaginaPublica cargar={bodasApi.publica} variante="boda" clave={slug} campoDatos="boda" titulo={tituloBoda} />;
}

export function ReferidoPublico() {
  const { codigo } = useParams();
  return <PaginaPublica cargar={bodasApi.referidoPublico} variante="referido" clave={codigo} campoDatos="tarjeta" titulo={tituloReferido} />;
}
